export default {
  lang: '简体中文',
  // QQ表情
  "qqface_Smile": "微笑",
  "qqface_Grimac": "撇嘴",
  "qqface_Drool": "色",
  "qqface_Scowl": "发呆",
  "qqface_Chill": "得意",
  "qqface_Sob": "流泪",
  "qqface_Shy": "害羞",
  "qqface_Silent": "闭嘴",
  "qqface_Sleep": "睡",
  "qqface_Cry": "大哭",
  "qqface_Awkward": "尴尬",
  "qqface_Angry": "发怒",
  "qqface_Tongue": "调皮",
  "qqface_Grin": "呲牙",
  "qqface_Surprise": "惊讶",
  "qqface_Frown": "难过",
  "qqface_CoolGuy": "酷",
  "qqface_Helpless": "冷汗",
  "qqface_Scream": "抓狂",
  "qqface_Puke": "吐",
  "qqface_Chuckle": "偷笑",
  "qqface_Joyful": "可爱",
  "qqface_Slight": "白眼",
  "qqface_Smug": "傲慢",
  "qqface_Hungry": "饥饿",
  "qqface_Drowsy": "困",
  "qqface_Panic": "惊恐",
  "qqface_Sweat": "流汗",
  "qqface_Laugh": "憨笑",
  "qqface_Commando": "大兵",
  "qqface_Determined": "奋斗",
  "qqface_Scold": "咒骂",
  "qqface_Confused": "疑问",
  "qqface_Shhh": "嘘...",
  "qqface_Dizzy": "晕",
  "qqface_Torturing": "折磨",
  "qqface_Toasted": "衰",
  "qqface_Skull": "骷髅",
  "qqface_Hammer": "敲打",
  "qqface_Bye": "再见",
  "qqface_Speechless": "擦汗",
  "qqface_NosePick": "抠鼻",
  "qqface_Clap": "鼓掌",
  "qqface_Embarrased": "糗大了",
  "qqface_Trick": "坏笑",
  "qqface_Hum!L": "左哼哼",
  "qqface_Hum!R": "右哼哼",
  "qqface_Yawn": "哈欠",
  "qqface_Pooh-pooh": "鄙视",
  "qqface_Shrunken": "委屈",
  "qqface_TearingUp": "快哭了",
  "qqface_Sly": "阴险",
  "qqface_Kiss": "亲亲",
  "qqface_What!": "吓",
  "qqface_Whimper": "可怜",
  "qqface_Cleaver": "菜刀",
  "qqface_Watermelon": "西瓜",
  "qqface_Beer": "啤酒",
  "qqface_Basketball": "篮球",
  "qqface_Pingpong": "乒乓",
  "qqface_Coffee": "咖啡",
  "qqface_Rice": "饭",
  "qqface_Pig": "猪头",
  "qqface_Rose": "玫瑰",
  "qqface_Wilt": "凋谢",
  "qqface_Lips": "示爱",
  "qqface_Heart": "爱心",
  "qqface_BrokenHeart": "心碎",
  "qqface_Cake": "蛋糕",
  "qqface_Lightning": "闪电",
  "qqface_Bomb": "炸弹",
  "qqface_Knife": "刀",
  "qqface_Football": "足球",
  "qqface_Beetle": "瓢虫",
  "qqface_Poop": "便便",
  "qqface_Moon": "月亮",
  "qqface_Sun": "太阳",
  "qqface_Gift": "礼物",
  "qqface_Hug": "拥抱",
  "qqface_Thumbsup": "强",
  "qqface_Thumbsdown": "弱",
  "qqface_Shake": "握手",
  "qqface_Victory": "胜利",
  "qqface_Salute": "抱拳",
  "qqface_Beckon": "勾引",
  "qqface_Fist": "拳头",
  "qqface_Bad": "差劲",
  "qqface_LoveYou": "爱你",
  "qqface_NO": "NO",
  "qqface_OK": "OK",
  "qqface_Love": "爱情",
  "qqface_Blow_a_kiss": "飞吻",
  "qqface_Waddle": "跳跳",
  "qqface_Tremble": "发抖",
  "qqface_Aaagh!": "怄火",
  "qqface_Twirl": "转圈",
  "qqface_Kowtow": "磕头",
  "qqface_Turn_round": "回头",
  "qqface_Rope_Skipping": "跳绳",
  "qqface_Wave_hand": "挥手",
  "qqface_Excited": "激动",
  "qqface_Street_Dance": "街舞",
  "qqface_Give_a_kiss": "献吻",
  "qqface_Tai_Chi_L": "左太极",
  "qqface_Tai_Chi_R": "右太极",
  "qqface_Bliss": "双喜",
  "qqface_Firecracker": "鞭炮",
  "qqface_Lantern": "灯笼",
  "qqface_Fortune": "发财",
  "qqface_Karaoke": "K歌",
  "qqface_Shopping": "购物",
  "qqface_Email": "邮件",
  "qqface_Handsome": "帅",
  "qqface_Hurray": "喝彩",
  "qqface_Pray": "祈祷",
  "qqface_Furious": "爆筋",
  "qqface_Lollipop": "棒棒糖",
  "qqface_Drink_milk": "喝奶",
  "qqface_Noodles": "下面",
  "qqface_Banana": "香蕉",
  "qqface_Plane": "飞机",
  "qqface_Driving": "开车",
  "qqface_Highspeed_Rail_L": "高铁左车头",
  "qqface_Carriage": "车厢",
  "qqface_Highspeed_Rail_R": "高铁右车头",
  "qqface_Cloudy": "多云",
  "qqface_Rainy": "下雨",
  "qqface_Cash": "钞票",
  "qqface_Panda": "熊猫",
  "qqface_Light_bulb": "灯泡",
  "qqface_Windmill": "风车",
  "qqface_Alarm_Clock": "闹钟",
  "qqface_Umbrella": "大伞",
  "qqface_Balloon": "彩球",
  "qqface_Ring": "钻戒",
  "qqface_Sofa": "沙发",
  "qqface_Toilet_Paper": "纸巾",
  "qqface_Medicine": "药",
  "qqface_Pistol": "手枪",
  "qqface_Frog": "青蛙",
  "custom_Face": "自定义表情",
  // 通用UI展示信息
  "common_page_title": "在线客服",
  "common_sendbtn_text": "发送",
  "common_voicebtn_hold_text": "按住 说话",
  "common_voicebtn_release_text": "松开 发送",
  "common_voicebtn_cancel_text": "松开 取消",
  "common_insert_photo_text": "上传图片",
  "common_insert_emoji_text": "输入表情",
  "common_manual_close_text": "结束会话",
  "common_insert_file_text": "发送文件",
  "common_feed_back_text":"满意度",
  "common_screenshot_text": '截图',
  "common_screenshot_tip_QQ": "推荐使用QQ/微信截图",
  "common_screenshot_tip_mac": 'Mac：快捷键Shift+Command+4截图',
  "common_screenshot_tip_win": 'Windows：使用自带"截图工具"',
  "short_insert_photo_text": "照片",
  "short_insert_file_text": "文件",
  "common_insert_call_text": "音视频通话",
  "common_insert_audo_text": "转人工",
  "common_insert_businessCard_text": "发送名片",
  "common_insert_businessCard_balloon_text": "一键发送名片",
  "common_postarea_pc_placeholder": "请输入，按Enter直接发送消息，Ctrl+Enter换行",
  "common_postarea_Macpc_placeholder": "请输入，按Enter直接发送消息，Command+Enter换行",
  "common_postarea_mobile_placeholder": "请点击输入",
  "common_chatting_text": "交谈中",
  "common_leave_message_text": "留言了",
  "common_chatting_with_text": "与$1交谈中",
  "common_qq_chat_text": "去QQ交谈",
  "common_start_qq_chat_text": "发起QQ会话",
  "common_new_message_text": "你有【新消息】",
  "common_add_qq_friend_text": "添加QQ联系人",
  "common_confirm_text": "确定",
  "common_cancel_text": "取消",
  "common_tencent_certification": "",
  "common_lang_en": "英语",
  "common_lang_zh": "简体中文",
  "common_lang_zh-TW": "繁体中文",
  "common_tencent_translator": "腾讯翻译君实时翻译",
  "common_tencent_translator_fail": "翻译失败-腾讯翻译君",
  "common_tencent_translator_only": "仅支持中英互译-腾讯翻译君",
  "common_allow_text": "允许",
  "common_not_allow_text": "不允许",
  "common_read_all": "阅读全文",
  "common_typing": "正在输入...",
  "common_typing_human": "[正在输入...]",
  "common_view_all": "点击查看全部",
  "common_audio_text": "音频通话",
  "common_video_text": "视频通话",
  "common_video_confirm": "我知道了",
  "common_video_text_call": "前往通话",

  // 聊天相关信息
  "chat_max_post_limit_text": "发送消息过长，请分条发送。",
  "chat_history_msg_get_text": "点击加载更多历史消息",
  "chat_history_msg_get_error": "加载历史消息失败",
  "chat_history_msg_loading_text": "正在加载历史消息",
  "chat_offline_msg_loading_text": "正在加载新消息",
  "chat_offline_msg_fail_text": "新消息加载失败，点击重试",
  "chat_offline_msg_over_text": "以下为未读消息",
  "chat_menu_msg_loading_text": "正在加载菜单导航",
  "chat_menu_msg_fail_text": "菜单导航加载失败，点击重试",
  "chat_menu_msg_history_expired_text": "历史数据已失效",
  "chat_graphic_msg_readmore_text": "阅读原文",
  "chat_graphic_msg_viewdmore_text": "查看更多",

  "chat_feedback_title_text": "请为本次服务打分",
  "chat_feedback_submit_text": "提交",
  "chat_feedback_postarea_placeholder": "感谢您的评分，可留下其他意见或建议",
  "chat_feedback_submitting_text": "正在提交评价",
  "chat_feedback_success_msg": "提交成功",
  "chat_feedback_fail_msg": "提交失败",
  "chat_feedback_error_msg": "网络错误，请重试",
  "chat_feedback_very_dissatisfied_text": "很不满意",
  "chat_feedback_dissatisfied_text": "不满意",
  "chat_feedback_neutral_text": "一般",
  "chat_feedback_satisfied_text": "满意",
  "chat_feedback_very_satisfied_text": "很满意",

  "chat_add_friend_fetching_protocol_msg": "正在获取添加协议",
  "chat_add_friend_copy_success_msg": "复制成功",
  "chat_add_friend_fail_text": "失败",
  "chat_add_friend_fail_get_number_fail_text": "获取号码数据失败",
  "chat_add_friend_fail_no_text_selected_text": "没有选中文字，请手工复制",
  "chat_add_friend_fail_browser_not_support_text": "浏览器不支持，请手工复制",
  "chat_change_queue_immediately": '立即切换',
  "chat_close_session_confirm": "结束会话后，重新咨询可能需要排队，确认结束会话吗？",
  "chat_close_session_succ": "会话已结束，如需继续服务请直接发送消息",

  "chat_incoming": "正在接入，请稍候",
  "chat_incoming_success": "接入成功",
  "chat_incoming_timeout": "接入失败，请<a class=\"btn-refresh\" href=\"javascript:;\" onclick=\"location.reload();\">刷新页面</a>重试",
  "chat_incoming_timeout_inframe": "接入失败，请刷新页面重试",

  // 系统消息
  "sysmsg_load_corpinfo_msg": "正在加载企业信息",
  "sysmsg_load_corpinfo_fail_msg": "企业信息拉取失败",
  // 员工信息
  "sysmsg_load_staff_msg": "正在加载员工信息",
  "sysmsg_load_staff_fail_msg": "员工信息拉取失败",

  // 退出排队
  "exit_queque_btn": "退出排队",
  "exit_queue_confirm": "确认退出当前队伍么？",
  "exit_queue_success": "你已退出排队",
  "exit_queue_fail": "退出排队失败，请重试",

  // 顶部通知
  "notice_slider_header": "【公告】",
  "notice_popup_header": "企业公告",
  "notice_item_header": "【公告】",
  "notice_item_header_gjh": "【通知】",

  // 电商
  "ec_goods_text": "商品",
  "ec_order_text": "订单",

  //发送名片按钮
  "send_business_card_btn":"发送名片",

  // xml结构化消息
  "xml_product_name": "商品名称",
  "xml_product_exhibition_area": "商品展区",
  "xml_product_category": "商品类别",

  "xml_purchase_quantity": "采购数量",
  "xml_purchase_unit": "采购单位",

  "xml_buyer_name": "采购商名称",
  "xml_buyer_location": "采购商所在地",
  "xml_buyer_tag": "采购商属性标签",

  "xml_source_product":"采购产品",
  "xml_source_category":"产品分类",
  "xml_source_detail":"采购意向详情",
  "xml_buyer_company_name":"采购商公司名称",
  "xml_buyer_company_country":"公司所在地",
  
  "xml_exhibit_name":"展品名称",
  "xml_exhibit_uom":"单位",
  "xml_exhibit_price":'单价',
  "xml_exhibit_currency":"币种",
  "xml_exhibit_detail":"说明",

  "xml_exhibit_jump_tip":"点击查看详细采购意向",

  "sysmsg_msg_current_service_lang": "当前服务语言是",
  "sysmsg_msg_change_service_lang": "服务语言已更换为",

  // 消息已读回执
  "msg_unread": "未读",
  "msg_beenread": "已读",

  // AI消息的tip
  "ai_msg_tip": "该答案由AI助手产生，请谨慎鉴别",
};
